import { render, staticRenderFns } from "./OtherOfficeMessages.vue?vue&type=template&id=589b0f99&scoped=true&lang=pug"
import script from "./OtherOfficeMessages.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessages.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessages.vue?vue&type=style&index=0&id=589b0f99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b0f99",
  null
  
)

export default component.exports